<template>
  <v-layout align-center column style="margin-top:80px;">
    <p class="Section-Title">Pertanyaan Seputar Peminjaman</p>
    <div v-bind:style="{ width: widthComponent }">
      <v-divider></v-divider>
      <pertanyaan-content-mobile
        v-for="data in questions"
        :data="data"
        :key="data"
      />
    </div>
  </v-layout>
</template>
<script>
import PertanyaanContentMobile from "./PertanyaanContentMobile.vue";
export default {
  components: { PertanyaanContentMobile },
  data() {
    return {
      size: 0,
      widthComponent: 0,
      questions: [
        {
          title:
            "Apakah semua usaha bisa mendapatkan pinjaman dari Dompet Kilat?",
          detail: `Tidak. Dompet Kilat hanya memberikan pinjaman pada mitra usaha yang
        tergabung dalam kelompok binaan yang memiliki rantai pasokan yang jelas
        dalam industrinya.`,
          visible: true,
        },
        {
          title: "Bagaimana agar bisa mendapatkan pinjaman?",
          detail: `Kamu memiliki usaha minimal satu tahun dan tergabung dalam kelompok binaan.`,
          visible: false,
        },
        {
          title:
            "Apakah peminjam akan mendapatkan dana tunai dari Dompet Kilat?",
          detail: `Tidak. Dompet Kilat membelanjakan berbagai kebutuhan yang dibutuhkan oleh mitra usaha untuk mengembangkan usahanya.`,
          visible: false,
        },
        {
          title: "Kenapa Dompet Kilat tidak memberikan dana tunai?",
          detail: `Kami percaya bahwa memberikan kail dan ilmu lebih penting daripada hanya sekedar memberikan ikan. Kami juga melakukan pembinaan pada mitra usaha agar usahanya bisa lebih berkembang.`,
          visible: false,
        },
        {
          title: "Bagaimana kalau saya gagal melunasi pinjaman?",
          detail: `Tim kami akan melakukan evaluasi dan mencari solusi bersama dengan peminjam dan stakeholder terkait.`,
          visible: false,
        },
      ],
    };
  },
  mounted() {
    this.onResize();
  },
  destroyed() {
    window.removeEventListener("resize", this.resizeEventHandler);
  },
  created() {
    this.resizeEventHandler();
    window.addEventListener("resize", this.resizeEventHandler);
  },
  methods: {
    resizeEventHandler() {
      this.size = `${window.innerWidth / 2}px`;
      this.widthComponent = `${window.innerWidth / 1.2}px`;
    },
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
  },
};
</script>
<style scoped>
.Section-Title {
  width: 328px;
  height: 23px;
  flex-grow: 0;
  margin: 0 auto 31px;
  font-family: Sora;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #252525;
}
.Question {
  /* width: 1048px; */
  height: 361px;
  flex-grow: 0;
  margin: 50px 0 0;
  padding: 20px 0 0;
}
title {
  /* width: 533px; */
  height: 22px;
  flex-grow: 0;
  margin: 0 495px 12px 0;
  font-family: Inter;
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.Desc {
  /* width: 972px; */
  height: 38px;
  flex-grow: 0;
  margin: 12px 56px 20px 0;
  font-family: Inter;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.36;
  letter-spacing: normal;
  text-align: left;
  color: #252525;
}
.minus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 13px 56px;
  object-fit: contain;
}
.plus-circle {
  width: 20px;
  height: 20px;
  margin: 21px 30px 20px 56px;
  object-fit: contain;
  display: inline;
}
</style>
